@if(dataList){
  <app-cards-basic title="{{ 'DATAS.title' | translate: {count: 0} }}">

    <mat-nav-list>
      <a mat-list-item
         [routerLink]="['price-data' | localize]"
         class="list-border-bottom">
        <span matListItemTitle>{{ 'DATAS.price_data' | translate }}</span>
        <button mat-icon-button disabled aria-label="Delete" class="trailing-end-button">
          <mat-icon>
            <span class="material-symbols-outlined">lock</span>
          </mat-icon>
        </button>
      </a>

      @for (data of dataList; track data) {
        <a mat-list-item
           [routerLink]="[data.id]"
           class="list-border-bottom">
          <!--<span matListItemTitle>{{ data.data_json | parseJson: 'filename' }}</span>-->
          <span matListItemTitle>{{ data.translations[currentLanguage].title }}</span>
          <button mat-icon-button (click)="confirmDelete(data.id, $event)" aria-label="Delete" class="trailing-end-button">
            <mat-icon>
              <span class="material-symbols-outlined">delete</span>
            </mat-icon>
          </button>
        </a>
      }
    </mat-nav-list>

    <button mat-flat-button
            color="primary"
            type="button"
            [routerLink]="['new-datasource' | localize]"
            class="bp-button">
      {{ 'DATAS.create' | translate }}
    </button>


  </app-cards-basic>
}

